import { createSelector } from "reselect";

const getSuccess = state => state.register.success;
export const successMessage = createSelector(
  [getSuccess],
  success => (success ? "We successfully created your account" : ""),
);
